module.exports = __webpack_public_path__ + "static/jk-desk-d33c09e8c108c091eb2e2995a132799b.png";